<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="All investment" name="first"></el-tab-pane>
			<el-tab-pane label="New investment" name="second"></el-tab-pane>
			<!-- <el-tab-pane label="Loan calculator" name="third"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search by investor, investment ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<!-- <div class="md-layout-item md-small-size-100 md-size-20">
					<md-field>
						<label>Loan Type</label>
						<md-select placeholder="Loan Type (All)" v-model="search.type">
							<md-option value="">All</md-option>
							<md-option value="mpip">Monthly Principal + Interest</md-option>
							<md-option value="mip">Monthly Intereset</md-option>
						</md-select>
					</md-field>
				</div> -->
				<div class="md-layout-item md-small-size-100 md-size-20">
					<md-field>
						<label>Status</label>
						<md-select placeholder="Status (All)" v-model="search.status">
							<md-option value="">All</md-option>
							<md-option value="act">Active</md-option>
							<md-option value="fin">Finished</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>
			<md-table v-if="investmentList.length > 0">
				<md-table-row>
					<md-table-head>N.O</md-table-head>
					<md-table-head>Investment Date</md-table-head>
					<md-table-head>Investment ID</md-table-head>
					<md-table-head>Investment Amount</md-table-head>
					<md-table-head>Investor</md-table-head>
					<md-table-head>Next Payment</md-table-head>
					<md-table-head>Status</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>

				<md-table-row v-for="(investment, index) in investmentList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>{{ config.datelify(investment.start_date) }}</md-table-cell>
					<md-table-cell>{{ investment.hash_id }}</md-table-cell>
					<md-table-cell>{{ config.moneylify(investment.amount) }}</md-table-cell>
					<md-table-cell><b>ID: {{investment.client_hash_id}}</b> ({{investment.name}})</md-table-cell>
					<md-table-cell>
						<span v-if="investment.total_paid == investment.term || investment.status == 'fin'" class="active">Not
							Available</span>
						<span class="late"
							v-else-if="String(investment.next_payment).length >0 && config.timelify(investment.next_payment) == 'Late'">{{config.datelify(investment.next_payment)}}</span>
						<span class="active"
							v-else-if="String(investment.next_payment).length >0">{{config.datelify(investment.next_payment)}}
							({{config.timelify(investment.next_payment)}})</span>
					</md-table-cell>
					<md-table-cell>
						<span class="active" v-if="investment.status == 'act'">{{config.getStatus(investment.status)}}</span>
						<span class="late" v-if="investment.status == 'fin'">{{config.getStatus(investment.status)}}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/investment/detail/' + investment.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">View investment information</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(investment.hash_id)">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">Delete this investment</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="investmentList.length == 0 && loadMore == true">No investment data.</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>New Investment</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* required</span>
					</div>
					<div class="md-layout">
						<!-- <div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Loan Type *</label>
								<md-select placeholder="Loan Type *" v-model="investment.type" @md-selected="calculateInvestment()">
									<md-option value="mpip">Monthly Principal + Interest Payment</md-option>
									<md-option value="mip">Monthly Interest Payment</md-option>
								</md-select>
							</md-field>
						</div> -->
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Investment Term *</label>
								<md-select placeholder="Investment Term *" v-model="investment.term"
									@md-selected="calculateInvestment()">
									<md-option :value="i" v-for="i in 60">{{i}} Month(s)</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Investment Start Date</label>
								<md-input type="text" v-model="investment.start_date" style="display:none" />
								<datetime type="date" v-model="investment.start_date" auto></datetime>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Investment Amount *</label>
								<md-input type="number" v-model="investment.amount" @keyup="calculateInvestment()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Investment Interest *</label>
								<md-input type="number" v-model="investment.interest" @keyup="calculateInvestment()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Investment Fee *</label>
								<md-input type="number" v-model="investment.fee" @keyup="calculateInvestment()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Investment Remark</label>
								<md-input type="text" v-model="investment.note"></md-input>
							</md-field>
						</div>
						<!-- <div class="md-layout-item md-size-100 text-right">
							<md-button :class="{'md-raised': true, 'md-primary': investment.valid}" :disabled="!investment.valid" @click="">
								Preview</md-button>
						</div> -->
					</div>
					<!-- <div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<h3>Development Mode</h3>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Initial principal</label>
								<md-input type="text" v-model="investment.initial_principal"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Initial interest</label>
								<md-input type="text" v-model="investment.initial_interest"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Initial payment</label>
								<md-input type="text" v-model="investment.initial_payment"></md-input>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Monthly principal</label>
								<md-input type="text" v-model="investment.monthly_principal"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Monthly interest</label>
								<md-input type="text" v-model="investment.monthly_interest"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Monthly payment</label>
								<md-input type="text" v-model="investment.monthly_payment"></md-input>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Final principal</label>
								<md-input type="text" v-model="investment.final_principal"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Final interest</label>
								<md-input type="text" v-model="investment.final_interest"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Final payment</label>
								<md-input type="text" v-model="investment.final_payment"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Loan fee</label>
								<md-input type="text" v-model="investment.fee"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Total payment</label>
								<md-input type="text" v-model="investment.total_payment"></md-input>
							</md-field>
						</div>


					</div> -->
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Investor</h3>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-70 md-size-70">
								<md-field>
									<label>Search investor by name, phone or ID</label>
									<md-input type="text" v-model="search.text" @keyup.enter="searchInvestor()">
									</md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-30">
								<md-button class="md-raised md-primary" @click="searchInvestor()" style="width: 100%">Search
								</md-button>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-table>
									<md-table-row v-for="(investor, index) in search.investorList">
										<md-table-cell>
											<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
											<b>ID: {{investor.hash_id}}</b> ({{investor.name}}, {{investor.phone}})
										</md-table-cell>
										<md-table-cell class=" text-right">
											<md-button class="md-just-icon md-simple md-success" @click="addInvestor(investor)">
												<md-icon>add</md-icon>
												<md-tooltip md-direction="top">Add investor</md-tooltip>
											</md-button>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</div>

				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 40%;">Client</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>

									<span v-if="String(investment.investor_id).length > 0"
										style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
										<span><b>ID: {{investment.investor[0].hash_id}}</b>
											({{investment.investor[0].name}})</span>
										<md-button class="md-just-icon md-simple md-danger" @click="removeInvestor()">
											<md-icon>remove</md-icon>
											<md-tooltip md-direction="top">Remove client</md-tooltip>
										</md-button>
									</span>
									<span v-else>N/A</span>

								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investment Type</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="investment.type == 'mpip'">Monthly Principal + Interest Payment</span>
									<span v-else-if="investment.type == 'mip'">Monthly Interest Payment</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>

							<md-table-row>
								<md-table-cell>Investment Term</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investment.term).length > 0">{{investment.term}} Months</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investment Interest</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(investment.interest).length > 0 && investment.type == 'mpip'">{{investment.interest}}%
										per
										annual (p.a)</span>
									<span
										v-else-if="String(investment.interest).length > 0 && investment.type == 'mip'">{{investment.interest}}%
										per month (p.m)</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investment Amount</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(investment.amount).length > 0">{{config.moneylify(investment.amount)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investment Interest Amount</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(investment.interest_amount).length > 0">{{config.moneylify(investment.interest_amount)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Investment Fee</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investment.fee).length > 0">{{config.moneylify(investment.fee)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>

							<md-table-row>
								<md-table-cell>Initial Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(investment.initial_payment).length > 0">{{config.moneylify(investment.initial_payment)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Monthly Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(investment.monthly_payment).length > 0">{{config.moneylify(investment.monthly_payment)}}
										<template v-if="investment.term > 1">x ({{investment.term - 2}} Months)</template></span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Final Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(investment.final_payment).length > 0">{{config.moneylify(investment.final_payment)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Total Payment</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(investment.total_payment).length > 0"><b>{{config.moneylify(investment.total_payment)}}
											+ {{config.moneylify(investment.fee)}} Fee</b></span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>

				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="post()">
						Create</md-button>
				</div>

			</div>
		</div>

		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this investment ?"
			md-content="This investment will be deleted and can't be restored." md-confirm-text="Delete" md-cancel-text="Cancel"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			// this.getLocation();
			// this.getSettings();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					type: "",
					text: "",
					status: "",
					investorList: []
				},
				investment: {
					start_date: "",
					amount: "",
					interest: "",
					term: "",
					type: "mip",
					fee: "",
					interest_amount: "",

					initial_payment: "",
					initial_principal: "",
					initial_interest: "",

					monthly_payment: "",
					monthly_principal: "",
					monthly_interest: "",

					final_payment: "",
					final_principal: "",
					final_interest: "",

					total_payment: "",
					investor_id: "",
					note: "",
					investor: []
				},
				loadMore: true,
				investmentList: []

			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/investment/search", {
					text: this.search.text,
					type: this.search.type,
					status: this.search.status,
					offset: more ? this.investmentList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.investmentList = data.body.data;
				})

			},
			post() {
				this.investment.start_date = (new Date(this.investment.start_date)).getTime();
				this.$http.post(this.config.api + "/admin/investment/post", {
					investment: this.investment,
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = "first";
						this.searchHandler();
					}
				})
			},
			calculateInvestment() {
				console.log("hi");
				if (String(this.investment.interest).length > 0 && String(this.investment.amount).length > 0 && String(this.investment.type).length > 0 &&
				String(this.investment.term).length > 0 && parseInt(this.investment.term) > 2 && String(this.investment.fee).length > 0) {
					let initial_principal = 0;
					let initial_interest = parseFloat(this.investment.amount) * this.investment.interest / 100;
					let initial_payment = initial_principal + initial_interest;
					console.log(initial_principal);
					console.log(initial_interest);
					console.log(initial_payment);
					let monthly_interest = initial_interest;
					let monthly_principal = initial_principal;
					let monthly_payment = initial_payment;

					let final_interest = monthly_interest;
					let final_principal = parseFloat(this.investment.amount);
					let final_payment = final_interest + final_principal;

					let amount_interest = initial_interest * parseFloat(this.investment.term);
					let total_payment = amount_interest + parseFloat(this.investment.amount);

					this.investment.interest_amount = amount_interest;
					this.investment.total_payment = total_payment;

					this.investment.initial_payment = initial_payment;
					this.investment.initial_principal = initial_principal;
					this.investment.initial_interest = initial_interest;

					this.investment.monthly_payment = monthly_payment;
					this.investment.monthly_principal = monthly_principal;
					this.investment.monthly_interest = monthly_interest;

					this.investment.final_payment = final_payment;
					this.investment.final_principal = final_principal;
					this.investment.final_interest = final_interest;

				} else {
					this.investment.interest_amount = "";
					this.investment.total_payment = "";

					this.investment.initial_payment = "";
					this.investment.initial_principal = "";
					this.investment.initial_interest = "";

					this.investment.monthly_payment = "";
					this.investment.monthly_principal = "";
					this.investment.monthly_interest = "";

					this.investment.final_payment = "";
					this.investment.final_principal = "";
					this.investment.final_interest = "";
				}
			},
			searchInvestor() {
				this.$http.post(this.config.api + "/admin/investor/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.investorList = data.body.data;
				})
			},
			addInvestor(investor) {
				this.investment.investor_id = investor.id;
				this.investment.investor.push(investor);
				this.search.investorList = []
			},
			removeInvestor() {
				this.investment.investor_id = "";
				this.investment.investor = [];
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/investment/delete", {
					hash_id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "This investment was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Investment/View.vue